<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />

    <form @keydown.enter.prevent="submit()">
      <!-- data provider  -->
      <div>
        <!-- title  -->
        <h2 class="mb-1">{{ getMainTitle }}</h2>
        <v-row class="mb-0 pb-0">
          <v-col class="pb-0" cols="12" md="12">
            <el-PDF-viewer download :file="pdfFile" />
          </v-col>
          <v-col class="pb-0 pt-0" cols="12" md="12">
            <el-checkbox
              class="mt-0 mb-1"
              :disabled="qualifiedSignatureRequiredDisabled"
              label="Reikalingas pasirašymas kvalifikuotu el. parašu"
              tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Suteikiama teisė perįgalioti"
              v-model="qualifiedSignatureRequired"
            />
          </v-col>
          <template v-if="!canStamp && (!viewMode || formData.can_agree) && showCheckboxes">
            <v-col class="pt-0" cols="12" md="12">
              <el-checkbox
                required
                :disabled="modeReadonly"
                notTranslated
                :label="getConfirmText"
                v-model="agreements.confirm"
              >
              </el-checkbox>
            </v-col>
            <v-col class="py-0" cols="12" md="12">
              <el-checkbox
                required
                :disabled="modeReadonly"
                notTranslated
                :label="getReadUnderstoodText"
                v-model="agreements.read_understood"
              >
              </el-checkbox>
            </v-col>
            <v-col class="py-0" cols="12" md="12">
              <el-checkbox
                required
                :disabled="modeReadonly"
                notTranslated
                :label="getConfirmDataText"
                v-model="agreements.confirm_data"
              >
              </el-checkbox>
            </v-col>
          </template>
           <!-- SIGNATURES -->
          <v-col class="pt-4 pb-4" cols="12" md="12">
            <signatures-list
              :signatures="signatures"
              :editMySignatures="canEditSignatures"
              :mySignature="mySignature"
              :onlyOrder="onlyOrder"
              emitOnSave
              @saveEvent="saveSignatures"
              :loadingList="pageloading"
            ></signatures-list>
          </v-col>
          <v-col class="pt-0 pb-2" cols="12" md="12">
            <v-card  outlined>
              <v-card-text>
                <v-row>
                  <v-col class="pb-2" cols="12" >
                    <span><strong>{{ `${$t('Būsena')}: ` }}</strong><span :class="getStatusClass">{{ getStatus }}</span></span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <!-- actions  -->
      <v-card-actions v-if="!showSigningComponent">
        <v-row no-gutters>
          <v-spacer></v-spacer>
           <el-button
            class="mr-2"
            tile
            @click.native="back()"
            :loading="loading"
            :title="viewMode ? 'Atgal' : 'Atšaukti'"
          />
          <el-button
            v-if="canCancelSigning"
            class="mr-1"
            title="Atšaukti pasirašymą"
            :loading="loading"
            @click.native="beforeCancel()"
            color="secondary"
            icon="atšaukti"
          />
          <el-button
            class="mr-1"
            v-if="canRefuseToSign"
            title="Atsisakyti pasirašyti"
            :loading="loading"
            @click.native="beforeRefuse()"
            color="secondary"
            icon="atšaukti"
          />
          <template v-if="showTooltipBtn">
            <v-tooltip v-if="!viewMode" top max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  depressed
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  class="v-btn-primary"
                  :loading="loading"
                  @click.native="confirm()"
                  >
                  {{ $t('Perduoti atstovų patikrinimui') }}
                </v-btn>
              </template>
              <div class="tooltip-text">{{ $t('Registro tvarkytojas patikrins, ar nurodyti asmenys vadovaujantis Juridinių asmenų registro duomenimis turi teisę juridinio asmens vardu pasirašyti dokumentą. Patikrinimas gali užtrukti iki 2 darbo dienų.') }}</div>
          </v-tooltip>
          </template>
          <template v-else>
            <template v-if="qualifiedSignatureRequired">
              <template v-if="canInitQualifiedSignature">
                <el-button
                  title="Pasirašyti el. parašu"
                  :loading="loading"
                  @click.native="saveData()"
                  color="primary"
                  icon="pirmyn"
                />
              </template>
              <template v-else-if="canStamp">
                <el-button
                  class="mr-1"
                  title="Tęsti be spaudo"
                  :loading="loading"
                  @click.native="cancelStampRequired()"
                  color="secondary"
                />
                <el-button
                  title="Tvirtinti el. spaudu"
                  :loading="loading"
                  @click.native="initStamping()"
                  color="primary"
                  icon="pirmyn"
                />
              </template>
              <template v-else-if="canStartSigningProcess">
                <el-button
                  title="Perduoti pasirašymui"
                  :loading="loading"
                  @click.native="startSigningProcess()"
                  color="primary"
                  icon="pirmyn"
                />
              </template>
            </template>
            <template v-else>
              <el-button
                v-if="!viewMode"
                :title="getBtnText"
                :loading="loading"
                @click.native="confirm()"
                color="primary"
                icon="pirmyn"
              />
            </template>
          </template>
          <el-button
            v-if="viewMode && formData.can_agree && !qualifiedSignatureRequired"
            :title="$t('Pasirašyti')"
            :loading="loading"
            @click.native="sign()"
            color="primary"
            icon="pirmyn"
          />
        </v-row>
      </v-card-actions>
    </form>
    <modal-confirm
      :title="getBtnText"
      trueText="Pasirašyti"
      falseText="Ne"
      :code="getModalConfirmCode"
      v-model="showConfirmModal"
      :loading="loading"
      @confirmData="saveData"
    />
    <modal-confirm
      :title="getBtnSignText"
      v-model="showConfirmSignModal"
      :loading="loading"
      @confirmData="signData"
    />
    <modal-custom
      :title="$t('Pasirašymo atšaukimas')"
      :text="$t('Ar tikrai norite atšaukti pasirašymą?')"
      trueText="Taip"
      falseText="Ne"
      :loading="loading"
      v-model="showCancelModal"
      @confirmData="confirmCancel"
    />
    <modal-custom
      :title="$t('Atsisakymas pasirašyti')"
      :text="$t('Ar tikrai norite atsisakyti pasirašyti?')"
      trueText="Taip"
      falseText="Ne"
      :loading="loading"
      v-model="showRefuseModal"
      @confirmData="confirmRefuse"
    />
    <modal-custom
      :title="$t('Perduoti atstovų patikrinimui')"
      :text="$t('Registro tvarkytojas patikrins, ar nurodyti asmenys vadovaujantis Juridinių asmenų registro duomenimis turi teisę juridinio asmens vardu pasirašyti dokumentą. Patikrinimas gali užtrukti iki 2 darbo dienų.')"
      trueText="Perduoti patikrinimui"
      falseText="Ne"
      :loading="loading"
      v-model="showApproveRepresentersModal"
      @confirmData="saveData"
    />
    <modal-sign
      :openSign="showSigningComponent"
      :objectId="inJournalId"
      objectType="in_journal"
      @stampDecision="stampDecision"
      @cancelSigning="cancelSigning"
      @signed="signingSuccessfull"
    />
  </v-container>
</template>

<script>
import Enums from '@/enums'
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import unsavedData from '@/mixins/unsavedData'
import SignaturesList from '@/components/signatures/SignaturesList'
import ModalCustom from '@/components/modals/ModalCustom'
import ModalConfirm from '@/components/modals/ModalConfirm'
import errorNotifications from '@/mixins/errorNotifications'
import InJournalStatuses from '@/components/constants/inJournalStatus'
import SavitarnaMenu from '@/components/constants/savitarnaMenu.js'
import ModalSign from '@/components/modals/ModalSign.vue'

export default {
  name: 'MandateRefuseOrCancellation',
  components: {
    ModalConfirm, SignaturesList, ModalCustom, ModalSign
  },
  mixins: [userRole, unsavedData, errorNotifications],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      showApproveRepresentersModal: false,
      showCancelModal: false,
      showRefuseModal: false,
      pageloading: false,
      showAddPerson: false,
      loading: false,
      showSigningComponent: false,
      myAmnId: null,
      formData: {
        status: "801"
      },
      signatures: [],
      canEditSignatures: false,
      agreements: {
        confirm: false,
        read_understood: false,
        confirm_data: false,
      },
      additionalData: {
        kind: 'ITPSI',
        in_journal_type: null,
      },
      showConfirmModal: false,
      showConfirmSignModal: false,
      pdfFile: {},
      mySignature: {},
      showCheckboxes: true,
      onlyOrder: false,
      qualifiedSignatureRequired: false,
      inJournalId: null,
      stampRequired: false,
    }
  },
  computed: {
    canStartSigningProcess() {
      return this.qualifiedSignatureRequired
        && (this.formData.status == InJournalStatuses.RENGIAMAS)
        && this.signatures[0].amn_id != this.myAmnId
        && this.myAmnId != undefined
    },
    canInitQualifiedSignature() {
      return this.qualifiedSignatureRequired && !this.canStartSigningProcess
        && (this.formData.status == InJournalStatuses.RENGIAMAS
          || (this.formData.status == InJournalStatuses.LAUKIA_PASIRASYMO && this.formData.buttons.sign)
          || (this.formData.status == InJournalStatuses.LAUKIA_PATVIRTINIMO && this.formData.buttons.sign)
        )
    },
    canStamp() {
      return this.formData.buttons?.stamp;
    },
    qualifiedSignatureRequiredDisabled() {
      return this.formData.status != InJournalStatuses.RENGIAMAS
        && this.formData.status != InJournalStatuses.LAUKIA_PATVIRTINIMO
    },
    getStatus(){
      let statuses = this.$i18n.locale === 'lt' ? Enums.journalType.lt : Enums.journalType.en
      return statuses[this.formData.status]
    },
    getStatusClass(){
      return this.formData.status == InJournalStatuses.ATSAUKTAS ? 'text-red' : ''
    },
    canCancelSigning(){
      return this.formData.buttons?.cancelSigning
    },
    canRefuseToSign(){
      return this.formData.buttons?.refuseToSign
    },
    viewMode() {
      return this.$route.params.view || false
    },
    getConfirmText() {
      return this.notificationText(this.getTypeTerminate ? '000040' : '000044')
    },
    getReadUnderstoodText() {
      return this.notificationText(this.getTypeTerminate ? '000041' : '000045')
    },
    getConfirmDataText() {
      return this.notificationText(this.getTypeTerminate ? '000042' : '000046')
    },
    getModalConfirmCode() {
      return this.getTypeTerminate ? '000040' : '000044'
    },
    getValidateErrorCode() {
      return this.getTypeTerminate ? '000039' : '000043'
    },
    showTooltipBtn(){
      return !this.showCheckboxes
    },
    getBtnText() {
      return this.getTypeTerminate
        ? (this.showCheckboxes ? this.$t('Panaikinti įgaliojimą') : this.$t('Perduoti atstovų patikrinimui'))
        : (this.showCheckboxes ? this.$t('Atsisakyti įgaliojimo') : this.$t('Perduoti atstovų patikrinimui'))
    },
    getBtnSignText() {
      return this.getTypeTerminate
        ? this.$t('Pasirašyti įgaliojimo panaikinimą')
        : this.$t('Pasirašyti įgaliojimo atsisakymą')
    },
    getId() {
      return this.$route.params.id || null
    },
    getTypeTerminate() {
      return this.$route.name === 'savMandateTerminate'
    },
    getJournalType() {
      return this.getTypeTerminate ? '408' : '409'
    },
    modeReadonly() {
      return false
    },
    getMainTitle() {
      return this.getTypeTerminate
        ? this.$t('Įgaliojimo panaikinimas')
        : this.$t('Įgaliojimo atsisakymas')
    },
  },
  created() {
    this.getData()
    this.additionalData.in_journal_type = this.getTypeTerminate
  },
  methods: {
    stampDecision(decision) {
      this.stampRequired = decision
    },
    initElSigning() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.showSigningComponent = true
        } else {
          this.$root.$emit('FORMAT_ERROR_STEP')
        }
      })
    },

    initStamping() {
      this.showSigningComponent = true
    },

    cancelSigning() {
      this.showSigningComponent = false
      if (!this.viewMode) {
        if (this.getTypeTerminate) {
          this.$router.push({
              name: 'savMandateTerminate',
              params: {
                id: this.inJournalId,
                view: 'view'
              },
            })
          // location.reload()
        } else {
          this.$router.push({
              name: 'savMandateRefuse',
              params: {
                id: this.inJournalId,
                view: 'view'
              },
            })
          // location.reload()
        }
      }
    },

    cancelStampRequired() {
      this.pageloading = true
      this.$axios
        .post(`/gosign/cancel-stamping/${this.inJournalId}`)
        .then((res) => {
          if (res.data.toBasket) {
            window.location.href =  process.env.VUE_APP_BASKET_URL
          } else {
            let link = SavitarnaMenu.MANO_DOKUMENTAI
            window.location.href = link
            this.showSigningComponent = false
          }
        })
        .catch((err) => {
          if(err.response.status === 404){
            return this.$router.push({ name: 'sav404' })
          } else {
            this.$root.$emit('DATA_ERROR', err.response.data.message)
          }
        })
        .finally(() => {
          this.pageloading = false
        })
    },

    signingSuccessfull() {
      if (!this.stampRequired) {
        let link = SavitarnaMenu.MANO_DOKUMENTAI
        window.location.href = link
      } else if (this.getTypeTerminate) {
        this.$router.push({
            name: 'savMandateTerminate',
            params: {
              id: this.inJournalId,
              view: 'view'
            },
          })
        // location.reload()
      } else {
        this.$router.push({
            name: 'savMandateRefuse',
            params: {
              id: this.inJournalId,
              view: 'view'
            },
          })
        // location.reload()
      }

      this.showSigningComponent = false
    },

    saveSignatures(signatures) {
      if (signatures.length == 0) {
        // this.signatures = [this.mySignature]
      } else {
        this.signatures = signatures
      }
    },
    beforeCancel(){
      this.showCancelModal = true
    },
    beforeApproveRepresenters() {
      this.showApproveRepresentersModal = true;
    },
    beforeRefuse(){
      this.showRefuseModal = true
    },
    confirmRefuse() {
      this.refuse()
    },
    confirmCancel(){
      this.cancel()
    },
    cancel(){
      this.loading = true
      this.pageloading = true
      let formData = { ...this.formData }
      let url = `in-journals/${this.inJournalId}/cancel`
      this.$axios.post(url, formData)
      .then((res) => {
        this.$root.$emit('DATA_OK_STEP')
        // then
        this.initialForm()
        this.formData = {};
        this.pdfFile = {};
        return this.getData()
      }).catch((err) => {
        this.$root.$emit('DATA_ERROR', err)
      }).finally(() => {
        this.showCancelModal = false
        this.loading = false
        this.pageloading = false
      })
    },
    refuse(){
      this.loading = true
      this.pageloading = true
      let formData = { ...this.formData }
      let url = `in-journals/${this.getId}/refuse`
      this.$axios.post(url, formData)
      .then((res) => {
        this.$root.$emit('DATA_OK_STEP')
        // then
        this.initialForm()
        this.formData = {};
        this.pdfFile = {};
        return this.getData()
      }).catch((err) => {
        this.$root.$emit('DATA_ERROR', err)
      }).finally(() => {
        this.showRefuseModal = false
        this.loading = false
        this.pageloading = false
      })
    },
    back() {
      this.$router.go(-1)
    },
    confirm() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.showCheckboxes) {
            this.showConfirmModal = true
          } else {
            this.showApproveRepresentersModal = true
          }
        } else {
          this.$root.$emit('DATA_ERROR_CODE', this.getValidateErrorCode)
        }
      })
    },
    sign() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.showConfirmSignModal = true
        } else {
          this.$root.$emit('DATA_ERROR_CODE', this.getValidateErrorCode)
        }
      })
    },
    move(from, to){
      this.signatures.splice(to, 0, this.signatures.splice(from, 1)[0]);
    },
    getPdfFile() {
      this.pageloading = true
      // 408 - Panaikinimas, 409 - atsisakymas
      let url = "";
      if (this.viewMode){
        url = `in-journals/${this.getId}/preview`
      } else {
         url = `in-journals/${this.getId}/pregenerate/${this.getJournalType}`
      }
      this.$axios
        .get(url)
        .then((res) => {
          this.pdfFile = res.data
          this.pdfFile.original_filename = 'Peržiūra.pdf'
        })
        .catch((err) => {
          if(err.response.status === 404){
            return this.$router.push({ name: 'sav404' })
          } else {
              this.$root.$emit('DATA_ERROR', err.response.data.message)
          }
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    getData() {
      this.getPdfFile()
      this.pageloading = true
      if (this.viewMode || this.inJournalId) {
        let id = this.inJournalId || this.getId;
        this.$axios
          .get(`in-journals/${id}`)
          .then((res) => {
            this.inJournalId = res.data.inJournal.journal.id
            this.formData = res.data.inJournal
            this.signatures = res.data.inJournal.journal.signatures
            this.formData.buttons = res.data.inJournal.agreements.buttons
            this.formData.status = res.data.inJournal.journal.status
            this.qualifiedSignatureRequired = res.data.inJournal.journal.signature_required
          })
          .catch((err) => {
            if(err.response.status === 404){return}
            this.$root.$emit('DATA_ERROR', err.response.data.message)
          })
          .finally(() => {
            this.pageloading = false
          })
      } else {
        this.$axios
          .post(`mandates/${this.getId}/can-perform/${this.getJournalType}`)
          .then((res) => {
            this.$axios
              .get(`mandates/${this.getId}/mySignatures/${this.getJournalType}`)
              .then((res) => {
                this.signatures = res.data.signatures
                this.formData.status = res.data.status
                this.canEditSignatures = res.data.canEditSignatures
                this.showCheckboxes = res.data.showCheckboxes == true
                this.mySignature = res.data.mySignature
                this.onlyOrder = res.data.onlyOrder || false
                this.myAmnId = res.data.my_amn_id
              })
              .catch((err) => {
                if(err.response.status === 404){return}
                this.$root.$emit('DATA_ERROR', err.response.data.message)
              })
              .finally(() => {
                this.pageloading = false
              })
          }).catch((err) => {
              let link = SavitarnaMenu.MANO_DOKUMENTAI
              window.location.href = link
          })
      }
    },
    signData() {
      this.loading = true
      this.pageloading = true
      this.$axios.post(`in-journals/${this.formData.journal.id}/sign`)
        .then(res => {
            let link = SavitarnaMenu.MANO_DOKUMENTAI
            window.location.href = link
        })
        .catch(err => {
          this.$root.$emit('DATA_ERROR_CODE', '000088')
          this.pageloading = false
          this.loading = false
        })
    },
    startSigningProcess() {
      this.loading = true
      this.pageloading = true
      let formData = this.agreements
      formData.mandate_id = this.getId
      formData.journal_type = this.getJournalType
      formData.signature_required = this.qualifiedSignatureRequired
      formData.in_journal_id = this.inJournalId
      formData.signatures = [];
      this.signatures.map((signature, index) => {
        formData.signatures.push({
          amn_id: signature.amn_id,
          order_no: index+1,
          sms_enabled: signature.sms_enabled,
          phone_number: signature.phone_number,
          phone_number_prepend: signature.phone_number_prepend,
          email_enabled: signature.email_enabled,
          email_address: signature.email_address,
        })
      })
      let url = `in-journals/action`
      this.$axios
        .post(url, formData)
        .then((res) => {
          this.$set(this.formData, 'journal', res.data.data.journal)
          this.$set(this.formData, 'status', res.data.data.journal.status)
          this.$set(this.formData, 'buttons', res.data.data.agreements.buttons)
          this.$set(this.formData, 'status', res.data.data.journal.status)
          this.inJournalId = res.data.data.journal.id
          this.$root.$emit('DATA_OK_CODE', '000113')
            // redirect
            this.$router.push({
              name: 'savMandates',
            })
        })
        .catch((err) => {
          if(err.response.data.errors.signatures[1]){
            this.$root.$emit('DATA_ERROR_TEXT', err.response.data.errors.signatures[1])
          } else {
            this.$root.$emit('DATA_ERROR_CODE', '000088')
          }
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    saveData() {
      this.loading = true
      this.pageloading = true
      let formData = this.agreements
      formData.mandate_id = this.getId
      formData.journal_type = this.getJournalType
      formData.signature_required = this.qualifiedSignatureRequired
      formData.in_journal_id = this.inJournalId
      formData.signatures = [];
      this.signatures.map((signature, index) => {
        formData.signatures.push({
          amn_id: signature.amn_id,
          order_no: index+1,
          sms_enabled: signature.sms_enabled,
          phone_number: signature.phone_number,
          phone_number_prepend: signature.phone_number_prepend,
          email_enabled: signature.email_enabled,
          email_address: signature.email_address,
        })
      })
      let url = `in-journals/action`
      this.$axios
        .post(url, formData)
        .then((res) => {
          this.$set(this.formData, 'journal', res.data.data.journal)
          this.$set(this.formData, 'status', res.data.data.journal.status)
          this.$set(this.formData, 'buttons', res.data.data.agreements.buttons)
          this.$set(this.formData, 'status', res.data.data.journal.status)

          this.inJournalId = res.data.data.journal.id
          if (!this.canStartSigningProcess) {
            if (this.qualifiedSignatureRequired) {
              this.initElSigning()
            } else {
              if (res.data.data.journal.status == InJournalStatuses.LAUKIA_PASIRASYMO) {
                this.signData()
              } else {
                this.$root.$emit('DATA_OK_CODE', '000113')
                // redirect
                this.$router.push({
                  name: 'savMandates',
                })
              }
            }
          } else {
            this.$root.$emit('DATA_OK_CODE', '000113')
              // redirect
              this.$router.push({
                name: 'savMandates',
              })
          }
        })
        .catch((err) => {
          if(err.response.data.errors.signatures[1]){
            this.$root.$emit('DATA_ERROR_TEXT', err.response.data.errors.signatures[1])
          } else {
            this.$root.$emit('DATA_ERROR_CODE', '000088')
          }
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped></style>
